import { apiClient } from './client';

export function getDemoShopsReport (params: { from?: string; to?: string } = {}) {
  return apiClient.get('/reports/demo-mode', { params });
}

export interface DemoShopHistoryRow {
  shop_id: number;
  name: string | null;
  provider_domain: string | null;
  entered_demo_at: string;
  exited_demo_at: string;
  days_in_demo: number;
}

export interface DemoShopHistoryResponse {
  data: DemoShopHistoryRow[];
  meta: { total: number };
}

export function getDemoShopsHistory (params: { page?: number; per_page?: number } = {}) {
  return apiClient.get<DemoShopHistoryResponse>('/reports/demo-mode/history', { params });
}
